import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(pure);

const button = enhance(
  ({
    classes,
    cognitoUserId,
    shopName,
    shopId,
    onClickAction,
    groupEducateSystem
  }) => {
    const changeAction = () => {
      const params = {
        cognitoUserId,
        shopName,
        shopId,
        groupEducateSystem
      };
      onClickAction(params);
    };
    return (
      <Button color="primary" onClick={() => changeAction()}>
        <ExitToAppIcon className={classes.leftIcon} />
        店舗としてログイン
      </Button>
    );
  }
);

export default withStyles(styles)(button);
